module.exports = __webpack_public_path__ + "media/src/images/backgrounds/rewards-placeholder-aec13f52b9148a577a77d44c34c0ec10.svg";